import React from "react";
import { Navigate, Outlet } from "react-router";
import { useAuth } from "./context";

const PrivateRoutes = () => {
  const [auth] = useAuth();

  return auth?.user ? <Outlet /> : <Navigate to="/login" replace />;
};

export default PrivateRoutes;
